<script setup>
import CompetitorForm from '@frontJs/components/forms/projectManagement/modules/CompetitorForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, competitor, competitorSeoTypes, competitorSeaTypes, targets } =
    defineProps({
        tenant: {
            type: Object,
            required: true,
        },
        competitor: {
            type: Object,
            required: false,
        },
        competitorSeoTypes: {
            type: Array,
            required: true,
        },
        competitorSeaTypes: {
            type: Array,
            required: true,
        },
        targets: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="competitor">
            Mettre à jour le concurrent #{{ competitor.id }} - Concurrents
            Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un concurrent - Concurrents - Modules - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="competitor" :tenant-name="tenant.name">
        Gestion de projet - Modules - Concurrents - Mettre à jour le concurrent
        #{{ competitor.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Modules - Concurrents - Créer un concurrent
    </PageTitle>

    <CompetitorForm
        :tenant="tenant"
        :competitor="competitor"
        :competitor-seo-types="competitorSeoTypes"
        :competitor-sea-types="competitorSeaTypes"
        :targets="targets"
    />
</template>
